import { createContext } from 'react'

import { EMPTY_OBJECT, getDateTime } from '~/src/Lib/Utils'

export default createContext({
  selectedDate: getDateTime('now').startOf('day'),
  topItem: EMPTY_OBJECT,
})
